import { Link, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Breadcrumb = ({ pathname }) => {
  let pathNameArr = String(pathname).split("/");
  console.log("pathname array", pathNameArr);
  let name = pathNameArr[1];
  const location = useLocation();

  const newParams = new URLSearchParams(location.search);


  return (
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-9">
        <h2 className="text-capitalize m-0" style={{ color: "#000" }}>


          {name ? name.split("-").join(" ") : "Profile"}

        </h2>

        { }
      </div>
      <div class="col-lg-3 text-end">
        <div>
          {location.pathname.includes("/user-Message-Details/") ? (
            <Link to="/user-Messages/1" className="btn btn-primary">
              <i
                style={{ marginRight: "5px" }}
                className="fas fa-long-arrow-left"
              ></i>
              Back
            </Link>
          ) : null}
        </div>
        <div>
          {location.pathname.includes("/user/") ? (
            <Link to="/users/1" className="btn btn-primary">
              <i
                style={{ marginRight: "5px" }}
                className="fas fa-long-arrow-left"
              ></i>
              Back
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
